import React from 'react'
import Feature from '../components/Highlights/Feature'

function Highlights() {
    return (
        <Feature/>
    )
}

export default Highlights
